import React from "react";

// Shared validation-error banner (Phase A promotion, module 11 polish pass).
// Donor: EventWizard step-validation banner (module-00 pattern, duplicated
// above and below the step content per SH-006; also EmailForm). Server-error
// MUI <Alert severity="error"> usages stay as-is — this component owns only
// the "fix the following" list pattern.

export type ErrorBannerProps = {
  /** default "Please fix the following before continuing:" */
  heading?: string;
  /** Rendered as list-disc bullets; empty array -> renders nothing */
  messages: string[];
  /** Caller adds spacing, e.g. "mb-8" / "mt-8" (EventWizard uses both positions) */
  className?: string;
};

export const ErrorBanner: React.FC<ErrorBannerProps> = ({
  heading = "Please fix the following before continuing:",
  messages,
  className,
}) => {
  if (messages.length === 0) {
    return null;
  }

  return (
    <div
      className={`${
        className ? `${className} ` : ""
      }rounded border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-800`}
      role="alert"
    >
      <p className="font-extrabold">{heading}</p>
      <ul className="mt-2 list-disc space-y-1 pl-5">
        {messages.map((message) => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </div>
  );
};
